module.exports = __webpack_public_path__ + "img/1728544755308-Screenshot_10-10-2024_151743_www.instagram.com.jpeg.8e0c12d5.webp";